<template>
    <div class="other">
        <el-button type="primary" @click="clickmakeCustomized" v-if="isCustomized">生成定制图</el-button>
    </div>
</template>
<script lang="ts" setup>
import { useUserStore } from "@/stores/user";
const userStore = useUserStore();
import { ElButton } from 'element-plus'
import { clickmakeCustomized } from '@/common/design'
import { computed } from 'vue'
const islogin = userStore.isLoggedIn
const urlParams = new URLSearchParams(window.location.search)
const query = Object.fromEntries(urlParams.entries())

const isCustomized = computed(() => {
    return query.order_no && islogin
})

</script>
<style scoped lang="scss">
.other {
    display: flex;
    justify-content: flex-end;
    margin-right: 20px;
}
</style>
